/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */
import { Model } from '@app/shared/models/model.model';
import { Currency } from '@app/settings/currencies/currency.model';
import { CurrenciesAdditionsService } from '@app/shared/services/currencies-additions.service';
import { HotelBookingCancellation } from '@app/hotels/hotel-booking-cancellations/hotel-booking-cancellation.model';
import { Sale } from '@app/sales/sales/sale.model';

export class Night extends Model {
  id: number;
  date: string; // date
  net_price: number;
  net_price_currency_id: number;
  net_price_currency?: Currency;
  price: number;
  price_currency?: Currency;
  web_price: number;
  sold_price: number;
  status?: string;
  hotel_booking_cancellation_id: number;
  cancellation?: HotelBookingCancellation;
  sale_id?: number;
  extra?: boolean;
  min_night?: boolean;
  sale?: Sale;
  guest_names?: Array<string>;

  isNightAvailable(): boolean {
    return (this.sold_price <= 0 || !this.sold_price) && !this.hotel_booking_cancellation_id;
  }

  get margin() {
    return Number(this.price) - CurrenciesAdditionsService.toEUR(this.net_price, this.net_price_currency);
  }

  /**
   *  фиктивен сетър колкото да не пищи
   * @param m нищо
   */
  set margin(m: any) {}
}
